module.exports = __webpack_public_path__ + "static/media/mobile_archero2_page_area02_img_cn@2x.0077dab3.png";